// Theme: arctic-clear
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'arctic-clear',
  name: 'ARCTIC',
  tagline: 'ARCTIC',
  description: 'Azul artico em trilha free com contraste frio e leve.',
  category: 'organic-world',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#0D1A2A', '#29B6F6', '#142535', '#E0F7FF'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '16px',
      '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
      '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)'
    },
    shellClasses: 'font-sans theme-arctic-clear'
  },
  colorVars: {
    '--accent': '#29B6F6',
    '--accent-foreground': '#0D1A2A',
    '--background': '#0D1A2A',
    '--border': '#183149',
    '--card': '#142535',
    '--card-border-active': 'rgba(41, 182, 246, 0.10)',
    '--card-completed': '#142535',
    '--card-foreground': '#E0F7FF',
    '--card-glow': 'rgba(41, 182, 246, 0.03)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#0D1A2A',
    '--foreground': '#E0F7FF',
    '--hold-fill': '#29B6F6',
    '--input': '#183149',
    '--modal-bg': '#0D1A2A',
    '--modal-border': '#183149',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#183149',
    '--muted-foreground': '#D2ECF9',
    '--nav-active': '#29B6F6',
    '--nav-bg': '#0D1A2A',
    '--popover': '#142535',
    '--popover-foreground': '#E0F7FF',
    '--primary': '#29B6F6',
    '--primary-foreground': '#0D1A2A',
    '--ring': '#29B6F6',
    '--secondary': '#183149',
    '--secondary-foreground': '#E0F7FF',
    '--streak': '#29B6F6',
    '--success': '#22C55E',
    '--success-foreground': '#0D1A2A',
    '--xp': '#29B6F6',
    '--xp-bg': '#142535'
  },
  resolvedVars: {
    '--accent': '#29B6F6',
    '--accent-foreground': '#0D1A2A',
    '--accent-foreground-hsl': '213 53% 11%',
    '--accent-foreground-oklch': 'from #0D1A2A l c h',
    '--accent-hsl': '199 92% 56%',
    '--accent-oklch': 'from #29B6F6 l c h',
    '--background': '#0D1A2A',
    '--background-hsl': '213 53% 11%',
    '--background-oklch': 'from #0D1A2A l c h',
    '--border': '#183149',
    '--border-hsl': '209 51% 19%',
    '--border-oklch': 'from #183149 l c h',
    '--border-w': '1px',
    '--card': '#142535',
    '--card-border-active': 'rgba(41, 182, 246, 0.10)',
    '--card-completed': '#142535',
    '--card-completed-hsl': '209 45% 14%',
    '--card-completed-oklch': 'from #142535 l c h',
    '--card-foreground': '#E0F7FF',
    '--card-foreground-hsl': '195 100% 94%',
    '--card-foreground-oklch': 'from #E0F7FF l c h',
    '--card-glow': 'rgba(41, 182, 246, 0.03)',
    '--card-hsl': '209 45% 14%',
    '--card-oklch': 'from #142535 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#EF4444',
    '--destructive-foreground': '#0D1A2A',
    '--destructive-foreground-hsl': '213 53% 11%',
    '--destructive-foreground-oklch': 'from #0D1A2A l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #EF4444 l c h',
    '--foreground': '#E0F7FF',
    '--foreground-hsl': '195 100% 94%',
    '--foreground-oklch': 'from #E0F7FF l c h',
    '--hold-fill': '#29B6F6',
    '--hold-fill-hsl': '199 92% 56%',
    '--hold-fill-oklch': 'from #29B6F6 l c h',
    '--input': '#183149',
    '--input-hsl': '209 51% 19%',
    '--input-oklch': 'from #183149 l c h',
    '--modal-bg': '#0D1A2A',
    '--modal-bg-hsl': '213 53% 11%',
    '--modal-bg-oklch': 'from #0D1A2A l c h',
    '--modal-border': '#183149',
    '--modal-border-hsl': '209 51% 19%',
    '--modal-border-oklch': 'from #183149 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#183149',
    '--muted-foreground': '#D2ECF9',
    '--muted-foreground-hsl': '200 76% 90%',
    '--muted-foreground-oklch': 'from #D2ECF9 l c h',
    '--muted-hsl': '209 51% 19%',
    '--muted-oklch': 'from #183149 l c h',
    '--nav-active': '#29B6F6',
    '--nav-active-hsl': '199 92% 56%',
    '--nav-active-oklch': 'from #29B6F6 l c h',
    '--nav-bg': '#0D1A2A',
    '--nav-bg-hsl': '213 53% 11%',
    '--nav-bg-oklch': 'from #0D1A2A l c h',
    '--popover': '#142535',
    '--popover-foreground': '#E0F7FF',
    '--popover-foreground-hsl': '195 100% 94%',
    '--popover-foreground-oklch': 'from #E0F7FF l c h',
    '--popover-hsl': '209 45% 14%',
    '--popover-oklch': 'from #142535 l c h',
    '--primary': '#29B6F6',
    '--primary-foreground': '#0D1A2A',
    '--primary-foreground-hsl': '213 53% 11%',
    '--primary-foreground-oklch': 'from #0D1A2A l c h',
    '--primary-hsl': '199 92% 56%',
    '--primary-oklch': 'from #29B6F6 l c h',
    '--radius': '16px',
    '--ring': '#29B6F6',
    '--ring-hsl': '199 92% 56%',
    '--ring-oklch': 'from #29B6F6 l c h',
    '--secondary': '#183149',
    '--secondary-foreground': '#E0F7FF',
    '--secondary-foreground-hsl': '195 100% 94%',
    '--secondary-foreground-oklch': 'from #E0F7FF l c h',
    '--secondary-hsl': '209 51% 19%',
    '--secondary-oklch': 'from #183149 l c h',
    '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)',
    '--streak': '#29B6F6',
    '--streak-hsl': '199 92% 56%',
    '--streak-oklch': 'from #29B6F6 l c h',
    '--success': '#22C55E',
    '--success-foreground': '#0D1A2A',
    '--success-foreground-hsl': '213 53% 11%',
    '--success-foreground-oklch': 'from #0D1A2A l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22C55E l c h',
    '--tint-primary-subtle': 'hsla(199 92% 56% / 0.15)',
    '--xp': '#29B6F6',
    '--xp-bg': '#142535',
    '--xp-bg-hsl': '209 45% 14%',
    '--xp-bg-oklch': 'from #142535 l c h',
    '--xp-hsl': '199 92% 56%',
    '--xp-oklch': 'from #29B6F6 l c h'
  }
}
